import { createEstacaoDeImpressao, deleteEstacaoDeImpressao, findEstacaoDeImpressaoById, findEstacoesDeImpressaoPorLoja, updateEstacaoDeImpressao } from "@/api/EstacaoDeImpressao"
import { EstacaoDeImpressao } from "@/models/EstacaoDeImpressao"
import { EstacaoDeImpressaoServiceAdapter } from "@/usecases"
import { AxiosRequestConfig } from "axios"
import { injectable } from "inversify-props"

@injectable()
export class EstacaoDeImpressaoService implements EstacaoDeImpressaoServiceAdapter {
	createEstacaoDeImpressao = async (estacao: EstacaoDeImpressao) => await createEstacaoDeImpressao(estacao)
	updateEstacaoDeImpressao = async (estacaoId: string, estacao: EstacaoDeImpressao) => await updateEstacaoDeImpressao(estacaoId, estacao)
	findEstacoesDeImpressaoPorLoja = async (lojaId: string, apenasAtivas?: boolean, config?: AxiosRequestConfig) => await findEstacoesDeImpressaoPorLoja(lojaId, apenasAtivas, config)
	findEstacaoDeImpressaoById = async (estacaoId: string, config?: AxiosRequestConfig) => await findEstacaoDeImpressaoById(estacaoId, config)
	deleteEstacaoDeImpressao = async (estacaoId: string, config?: AxiosRequestConfig) => await deleteEstacaoDeImpressao(estacaoId, config)
}
